import React from 'react';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { useAppSelector } from 'hooks/redux';

import ScheduledTransactionEditFormProvider from './components/ScheduledTransactionEditFormProvider';
import LegacyScheduledTransactionEditDialog from './legacy/ScheduledTransactionEditDialog';
import type { ScheduledTransactionEditDialogProps } from './types';

export type { ScheduledTransactionEditDialogProps } from './types';
export { getInitialSeriesSplitForScheduledTransactionEditForm as getInitialSeriesSplitForForm } from 'app-components/flux/scheduled-transactions/scheduledTransactionEditForm';
export {
  closeScheduledTransactionEditDialog,
  DIALOG_TYPE,
  showConfirmationIfDirty,
  showScheduledTransactionEditDialog,
} from './actions';

export const getScheduledTransactionEditDialogComponent = (isV2: boolean) =>
  isV2 ? ScheduledTransactionEditFormProvider : LegacyScheduledTransactionEditDialog;

function ScheduledTransactionEditDialog(props: ScheduledTransactionEditDialogProps) {
  const isV2 = useAppSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'scheduledTransactionEditV2'));
  const Component = getScheduledTransactionEditDialogComponent(Boolean(isV2));
  return <Component {...props} />;
}

export default ScheduledTransactionEditDialog;
